import { ChangeDetectorRef, Component, EventEmitter, Output, TemplateRef, ViewChild } from '@angular/core';
import { OneWebComponentsAngularModule } from '@one/angular';
import { Observable } from 'rxjs';
import { snackbarService } from '@one/web-components';
import { QnSbnDataServiceService } from '../../../../services/qn-sbn-data-service.service';
import { RecipientsFilterService } from '../../filter/recipients-filter/recipients-filter.service';
import { CommonModule, NgIf } from '@angular/common';
import { RecipientsSearchService } from '../../search/recipients-search/recipients-search.service';
import { RexisSapDialogComponent } from '../../../../rexis-sap-dialog/rexis-sap-dialog.component';
import { FormsModule } from '@angular/forms';
import { ColumnIssue, ImportDialogFileComponent } from '../../import-dialog-file/import-dialog-file.component';
import { RecipientsTableService } from './recipients-table.service';

export interface RecipientModal {
  recipientListTable: [];
  sourceName: [];
}

export interface AppState {
  readonly recipientsState: RecipientModal[];
}

@Component({
  selector: 'dl-recipients-table',
  standalone: true,
  imports: [OneWebComponentsAngularModule, CommonModule, RexisSapDialogComponent, FormsModule, ImportDialogFileComponent],
  templateUrl: './recipients-table.component.html',
  styleUrl: './recipients-table.component.scss'
})
export class RecipientsTableComponent {
  @ViewChild('myTemplate') recipientTemplate: TemplateRef<any>;
  public fileData = [];
  public dialogKey: number = 0;
  public emptyContactList: any;
  public columnData: any;
  public displayedColumns = ['select', 'customerID', 'customerName', 'customerContactName', 'customerContactEmail', 'source', 'expandTrigger'];
  public selection = [];
  dataSource: any[] = [];
  tableData: any[] = [];
  selectedRows: any[] = [];
  public filterArray: any[] = [];
  public isDeleteBtnDisabled = true;
  public deleteImport = false;
  public arrSelectedCustomerId: string[] = [];
  public dataTobestore: Observable<RecipientModal[]>;
  public sourceNameForStore = [];
  recipientData$: Observable<any>;
  public expandedElement: any;
  public isEmail: boolean = false;
  public isName: boolean = false;
  public openFromFile: boolean = false;
  public fromRexisap: boolean = false;
  // Blank column warning modal
  public showBlankColumnWarning = false;
  public blankColumnIssues: ColumnIssue[] = [];

  public handleBlankColumnsDetected(issues: ColumnIssue[]): void {
    this.blankColumnIssues = issues;
    this.showBlankColumnWarning = true;
  }

  public formatEmptyRows(rows: number[]): string {
    const max = 10;
    if (rows.length <= max) return rows.join(', ');
    return `${rows.slice(0, max).join(', ')} (+${rows.length - max} more)`;
  }
 // Pagination properties
  public pageSize = 25;
  public currentPage = 0;
  public pagedData = [];
  public totalPages = 0;
  public totalCount = 0;
  public pageSizeOptions = [10, 25, 50, 100, 250, 500];
  public mainAccounts:any=[];
  public accountsAndContactsStats:any=[];

  @Output() public isLimit = new EventEmitter<boolean>();
  public contactLimitNumber: number = 5000;
  @Output() public isWarn = new EventEmitter<boolean>();
  @Output() public dataCount = new EventEmitter<[number,number]>();
  public isImportBtnExpanded = false;
  public inputData: { fileData: any[], columnData: string[] } = {
    fileData: [],
    columnData: []
  };
  sortInfo: { column: string, direction: string }[] = [{ column: 'DateDelivered', direction: 'desc' }];

  public constructor(private changeDetectorRef: ChangeDetectorRef, private recipientsFilterService: RecipientsFilterService, private recipientsSearchService: RecipientsSearchService,
    private _QnSbnDataService: QnSbnDataServiceService,private recipientsTableService: RecipientsTableService,) { }


  public ngOnInit(): void {
    this.sortInfo = [{ column: 'CreationDate', direction: 'desc' }];

    this._QnSbnDataService.mappingData$.subscribe(observer => {

      if (!this._QnSbnDataService.isEmpty(observer['recipientData'])) {
        this.dataSource = observer['recipientData']['recipientTable'];
        if(this.dataSource.length>0){
          const allAccounts = this.dataSource.map(i => i.customerId);
          this.mainAccounts = [...new Set(allAccounts)];
          this.accountsAndContactsStats=[this.dataSource.length,this.mainAccounts.length]
          this.dataCount.emit(this.accountsAndContactsStats);
        }
        else{
          this.dataCount.emit([0,0]);
        }
        this.recipientsTableService.data(this.dataSource)
        this.tableData = observer['recipientData']['recipientTable'];
        this.sourceNameForStore = observer['recipientData']['sourceName'];
        this.setupPagination();
        this.recipientsSearchService.searchData$.subscribe(searchValue => {
          if (!this.tableData || this.tableData.length === 0) {
            return;  // data not ready yet
          }
          if (!searchValue || searchValue.trim() === '') {
            this.dataSource = this.tableData; // reset to full data when search is empty
          } else {
            const lowerSearch = searchValue.trim().toLowerCase();
            this.dataSource = this.tableData.filter((data: any) => {
              return (data.customerId && data.customerId.toLowerCase().includes(lowerSearch)) ||
                (data.customerName && data.customerName.toLowerCase().includes(lowerSearch)) ||
                (data.customerContactName && data.customerContactName.toLowerCase().includes(lowerSearch)) ||
                (data.customerEmail && data.customerEmail.toLowerCase().includes(lowerSearch));
            });
           

          }
          this.setupPagination();
          this.changeDetectorRef.detectChanges();
        });
      }
    })

    this.recipientsFilterService.filterData$.subscribe((searchValue: any[]) => {
      if (searchValue[0].length < 1) {
        if(searchValue[1].length < 1){
          this.pagedData = this.tableData;
        }
        this.recipientsTableService.setFilteredData(this.dataSource)
        this.changeDetectorRef.detectChanges();
      }
      else {
        if(searchValue[1].length!=0){
          searchValue[0].forEach(ele => {
          if (ele) {
            this.tableData.map(x => {
              if (x.sourceName && (x.sourceName.trim().toLowerCase() === ele)) {
                this.filterArray.push(x);
              }
            });
            this.pagedData = this.filterArray;
            this.recipientsTableService.setFilteredData(this.filterArray)
            this.changeDetectorRef.detectChanges();
          }
        });
        }
        else{
          searchValue[0].forEach(ele => {
          if (ele) {
            this.tableData.map(x => {
              if (x.sourceName && (x.sourceName.trim().toLowerCase() === ele)) {
                this.filterArray.push(x);
              }
            });
            this.pagedData = this.filterArray;
            this.recipientsTableService.setFilteredData(this.filterArray)
            this.changeDetectorRef.detectChanges();
          }
          });
        }
        this.filterArray = [];
      }
    });

    this.recipientsFilterService.warningfilterData$.subscribe(searchValue => {
      this.pagedData=searchValue;
      this.changeDetectorRef.detectChanges();
    });

     if(this.dataSource.length>0){
      const allAccounts = this.dataSource.map(i => i.customerId);
      this.mainAccounts = [...new Set(allAccounts)];
      this.accountsAndContactsStats=[this.dataSource.length,this.mainAccounts.length]
      this.dataCount.emit(this.accountsAndContactsStats);
    }else{
      this.dataCount.emit([0,0]);
    }
    if (this.dataSource.length <= this.contactLimitNumber) {
      this.isLimit.emit(false);
    } else {
      this.isLimit.emit(true);
    }
    const duplicates = this.findDuplicates(this.dataSource);
    const emptyFields = this.findEmpties(this.dataSource);
    if (duplicates.length > 0 || emptyFields.length > 0) {
      this.isWarn.emit(true);
    } else {
      this.isWarn.emit(false);
    }
  }

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
  }

  isSelected(row: any): boolean {
    return this.selectedRows.includes(row);
  }

  toggleSelection(row: any): void {
    const index = this.selectedRows.indexOf(row);
    if (index === -1) {
      this.selectedRows.push(row);
    } else {
      this.selectedRows.splice(index, 1);
    }
    this.validateBtnDeleteState();
  }

  isAllSelected(): boolean {
    const selectableRows = this.dataSource.filter(row => !row.disabled);
    return (
      selectableRows.length > 0 &&
      selectableRows.every(row => this.isSelected(row))
    );
  }

  isAllPageSelected(): boolean {
    const selectableRows = this.pagedData.filter(row => !row.disabled);
    return (
      selectableRows.length > 0 &&
      selectableRows.every(row => this.isSelected(row))
    );
  }

  masterToggle(): void {
    if (this.isAllPageSelected()) {
      // Remove all current page items from selection
      this.pagedData.forEach(row => {
        const index = this.selectedRows.indexOf(row);
        if (index > -1) {
          this.selectedRows.splice(index, 1);
        }
      });
    } else {
      // Add all selectable current page items to selection
      this.pagedData.filter(row => !row.disabled).forEach(row => {
        if (!this.isSelected(row)) {
          this.selectedRows.push(row);
        }
      });
    }
    this.validateBtnDeleteState();
  }

  validateBtnDeleteState(): void {
    this.isDeleteBtnDisabled = this.selectedRows.length === 0;
  }

  public addProduct(newData, sourcName) {
    this._QnSbnDataService.getMappedQnsbnData({
      recipientTable: newData,
      sourceName: sourcName
    }, "Recipient")
  }

  public openDialog(): void {
    this.isImportBtnExpanded = false;
    this.inputData = { fileData: null, columnData: null }; 
    this.openFromFile = true;
  }


  public handleDialogClose(result: any): void {
    this.openFromFile = false;  
   


    if (!result) {
      return;
    }

    this.fileData = result.fileData;
    this.columnData = result.columnData;
    this.emptyContactList = this.validateContactList(this.fileData);

    if (this.emptyContactList.emptyDataRow && this.emptyContactList.emptyDataRow.length > 0) {
      // const dialogRefEmpty = this.dialog.open(this.recipientTemplate, {
      //   data: { source: this.emptyContactList },
      //   disableClose: true
      // });
      this.openFromFile = false;

      return;
    }
    if (this.fileData != undefined) {

      this.dataSource = [
        ...this.dataSource,
        ...this.fileData.map(data => {
          return {
            customerId: data[this.columnData.Customer_ID].trim(),
            customerName: data[this.columnData.Customer_name].trim(),
            customerContactName: data[this.columnData.Customer_contact_name].trim(),
            customerEmail: data[this.columnData.Customer_contact_email].trim(),
            sourceName: result.sourceName
          };
        })
      ];
      const dataArray = Array.from(this.dataSource);

      if (dataArray.length <= this.contactLimitNumber) {
        this.isLimit.emit(false);
      } else {
        this.isLimit.emit(true);
      }
       if(this.dataSource.length>0){
          const allAccounts = this.dataSource.map(i => i.customerId);
          this.mainAccounts = [...new Set(allAccounts)];
          this.accountsAndContactsStats=[this.dataSource.length,this.mainAccounts.length]
          this.dataCount.emit(this.accountsAndContactsStats);
        }else{
          this.dataCount.emit([0,0]);
        }
      const duplicates = this.findDuplicates(dataArray);
      const emptyFields = this.findEmpties(dataArray);

      if (duplicates.length > 0 || emptyFields.length > 0) {
        this.isWarn.emit(true);
      } else {
        this.isWarn.emit(false);
      }
      this.recipientsFilterService.setSourceName(result.sourceName);
      this.sourceNameForStore = Object.assign([], this.sourceNameForStore);
      let sourceEle = { label: result.sourceName, value: result.sourceName };
      if (sourceEle.label !== '') {
        let checkEle = true;
        this.sourceNameForStore.some((el) => {
          if (el.label.trim().toLowerCase() === sourceEle.label.trim().toLowerCase()) {
            checkEle = false;
          }
        });
        if (checkEle) this.sourceNameForStore.push(sourceEle);
      }
      this.tableData = this.dataSource;
      this.addProduct(this.dataSource, this.sourceNameForStore);
      if (this.dataSource.length > 0) {
         this.snackBarMessage('positive', 'Recipient list imported successfully');
      }
    } else {
       this.snackBarMessage('alarm', 'There is some problem with recipient list');
    }
  }

  public validateContactList(contactList: any) {
    let invalidRecordIndex = [];
    let customEmptyData = [];
    const emptyRecords = contactList.filter((item, i) => {
      // || !item[this.columnData.Customer_name] || item[this.columnData.Customer_name].trim() === ''
      if (!item[this.columnData.Customer_contact_email] ||
        item[this.columnData.Customer_contact_email].trim() === '') {
        customEmptyData.push(
          {
            rowIndex: i + 1,
            customerId: item[this.columnData.Customer_ID] || '',
            customerName: item[this.columnData.Customer_name] || '',
            customerContactName: item[this.columnData.Customer_contact_name] || ''
          }
        );
        return item;
      };
    });
    const invalidData = {
      emptyData: emptyRecords,
      emptyDataRow: customEmptyData
    };
    return invalidData;
  }

  public closeEmptyAlertDialog() {
    // this.dialog.closeAll();
  }



  openDeleteConfirmDialog(): void {
    this.deleteImport = true;
  }

  closeDeleteModal(): void {
    this.deleteImport = false;
  }

  confirmDelete(): void {
    this.deleteImport = false;
    this.dataSource = this.dataSource.filter(row => !this.selectedRows.includes(row));
    this.tableData = this.tableData.filter(row => !this.selectedRows.includes(row));

    this.selectedRows = [];
    this.validateBtnDeleteState();

    const srcList: any[] = [];
    this.tableData.forEach(d => {
      const exists = srcList.some(
        el => el.label.trim().toLowerCase() === d.sourceName.trim().toLowerCase()
      );
      if (!exists && d.sourceName) {
        srcList.push({ label: d.sourceName, value: d.sourceName });
      }
    });
    this.sourceNameForStore = [...srcList];

    this.dataSource = [...this.tableData];

    this.addProduct(this.dataSource, this.sourceNameForStore);

    this.changeDetectorRef.detectChanges();
  this.snackBarMessage('positive', 'Recipient deleted successfully');

    this.isLimit.emit(this.dataSource.length > this.contactLimitNumber);

    const duplicates = this.findDuplicates(this.dataSource);
    const emptyFields = this.findEmpties(this.dataSource);
    this.isWarn.emit(duplicates.length > 0 || emptyFields.length > 0);
  }


  handleChecked(row: any) {
    if (!row.disabled) {
      // this.selection.toggle(row);
    }
  }

  expandToggle(element: any) {
    this.expandedElement = this.expandedElement !== element && !element.disabled ? element : null;
  }

  isExpanded(row: any) {
    return row === this.expandedElement;
  }

  public isDuplicated(d: any, target: any): boolean {
    if (!d || !target) return false;
    return this.isDuplicatedEmail(d, target) || this.isDuplicatedName(d, target);
  }

  public isDuplicatedEmail(d: any, target: any): boolean {
    if (!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) =>
      index !== targetIndex &&
      obj.customerId === target.customerId &&
      obj.customerEmail === target.customerEmail);
  }

  public isDuplicatedName(d: any, target: any): boolean {
    if (!d || !target) return false;
    const targetIndex = d.indexOf(target);
    return d.some((obj, index) =>
      index !== targetIndex &&
      obj.customerId === target.customerId &&
      obj.customerName !== target.customerName);
  }

  public findDuplicates(arr) {
    return arr.filter((target, index) => {
      return (
        arr.some((obj, targetIndex) =>
          index !== targetIndex &&
          obj.customerId === target.customerId &&
          obj.customerEmail === target.customerEmail)
      )
        || (
          arr.some((obj, targetIndex) =>
            index !== targetIndex &&
            obj.customerId === target.customerId &&
            obj.customerName !== target.customerName)
        );
    });
  }

  public findEmpties(arr: any[]): any[] {
    return arr.filter(i => {
      return (
        i.customerContactName === undefined || i.customerContactName === null || i.customerContactName === '' ||
        i.customerEmail === undefined || i.customerEmail === null || i.customerEmail === '' ||
        i.customerId === undefined || i.customerId === null || i.customerId === '' ||
        i.customerName === undefined || i.customerName === null || i.customerName === '' ||
        i.sourceName === undefined || i.sourceName === null || i.sourceName === ''
      );
    });
  }


  public btnImportClicked(): void {
    this.isImportBtnExpanded = !this.isImportBtnExpanded;
  }

  public fromRexisSap() {
    this._QnSbnDataService.hideActionBar$.next(true);
    this.fromRexisap = true;
    this.isImportBtnExpanded = false;
  }

  public handleRexisDialogClose(result: any): void {
    this._QnSbnDataService.hideActionBar$.next(false);
    this.fromRexisap = false;

    if (!result || result === 'cancel') {
      return;
    }

    const rexSapDataSelected = result;

    this.dataSource = [
      ...this.dataSource,
      ...rexSapDataSelected.map(data => ({
        customerId: data.erpAccountNo,
        customerName: data.accountName || data.name,
        customerContactName: data.contactName,
        customerEmail: data.contactEmail,
        sourceName: 'Rexis/SAP'
      }))
    ];

    if (this.dataSource.length <= this.contactLimitNumber) {
      this.isLimit.emit(false);
    } else {
      this.isLimit.emit(true);
    }
    if(this.dataSource.length>0){
      const allAccounts = this.dataSource.map(i => i.customerId);
      this.mainAccounts = [...new Set(allAccounts)];
      this.accountsAndContactsStats=[this.dataSource.length,this.mainAccounts.length]
      this.dataCount.emit(this.accountsAndContactsStats);
    }else{
      this.dataCount.emit([0,0]);
    }
    const duplicates = this.findDuplicates(this.dataSource);
    const emptyFields = this.findEmpties(this.dataSource);

    this.isWarn.emit(duplicates.length > 0 || emptyFields.length > 0);

    this.recipientsFilterService.setSourceName('Rexis/SAP');

    let sourceEle = { label: 'Rexis/SAP', value: 'Rexis/SAP' };
    const exists = this.sourceNameForStore.some(el => el.label.trim().toLowerCase() === sourceEle.label.trim().toLowerCase());
    if (!exists) this.sourceNameForStore.push(sourceEle);

    this.tableData = this.dataSource;
    this.addProduct(this.dataSource, this.sourceNameForStore);

    if (this.dataSource.length > 0) {
        this.snackBarMessage('positive', 'Recipient list imported successfully');
    }
  }


  isEmpty(data) {
    if ((data.customerContactName === undefined || '' || null) || (data.customerEmail === undefined || '' || null) || (data.customerId === undefined || '' || null) || (data.customerName === undefined || '' || null) || (data.sourceName === undefined || '' || null)) {
      return true
    }
    return false
  }

public OnSort(column: string, value: string): void {

  // remove existing sort for same column
  const existingSortIndex = this.sortInfo.findIndex(sort => sort.column === column);
  if (existingSortIndex !== -1) {
    this.sortInfo.splice(existingSortIndex, 1);
  }

  // add new sort if not default
  if (value !== 'default') {
    this.sortInfo.push({ column, direction: value });
  }

}

applySorting(data: any[]): any[] {
  const dataCopy = [...data];
  if (this.sortInfo.length > 0) {
    return dataCopy.sort((a, b) => {
      for (let i = this.sortInfo.length - 1; i >= 0; i--) {
        const { column, direction } = this.sortInfo[i];
        const aValue = a[column] ?? '';
        const bValue = b[column] ?? '';
        if (aValue < bValue) return direction === 'asc' ? -1 : 1;
        if (aValue > bValue) return direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  }
  return dataCopy;
}

 setupPagination() {
    if (!Array.isArray(this.dataSource)) {
      this.pagedData = [];
      this.totalPages = 0;
      this.totalCount = 0;
      return;
    }
    this.totalCount = this.dataSource.length;
    this.totalPages = Math.ceil(this.totalCount / this.pageSize);
    this.currentPage = 0;
    this.updatePagedData();
  }

  updatePagedData() {
    const start = this.currentPage * this.pageSize;
    const end = start + this.pageSize;
    this.pagedData = this.dataSource.slice(start, end);
  }

  // Dashboard-style pagination getters
  get startIndex(): number {
    return this.currentPage * this.pageSize + 1;
  }

  get endIndex(): number {
    const end = (this.currentPage + 1) * this.pageSize;
    return Math.min(end, this.totalCount);
  }

  // Dashboard-style pagination methods
  onPageSizeChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    this.pageSize = parseInt(target.value, 10);
    this.currentPage = 0;
    this.setupPagination();
  }

  goToPreviousPage(): void {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePagedData();
    }
  }

  goToNextPage(): void {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.updatePagedData();
    }
  }

  goToPage(page: number) {
    if (page < 0 || page >= this.totalPages) return;
    this.currentPage = page;
    this.updatePagedData();
  }

  nextPage() {
    if (this.currentPage < this.totalPages - 1) {
      this.currentPage++;
      this.updatePagedData();
    }
  }

  prevPage() {
    if (this.currentPage > 0) {
      this.currentPage--;
      this.updatePagedData();
    }
  }

   snackBarMessage(status: any, message: string) {
      snackbarService.show({
        message: message,
        snackbarProps: {
          status: status,
          direction: 'horizontal',
          showClose: true,
          elevated: false,
          duration: 5000,
          verticalPlacement: 'top',
          horizontalPlacement: 'right',
        }
      });
    }
}
